import { Item, Content as RadContent, Root } from '@radix-ui/react-accordion';
import { useEffect, useRef } from 'react';

import useHeaderStore from 'layout/header/store';
import useStopBodyScroll from 'layout/header/utils/useStopBodyScroll';

import type { FC, ReactNode } from 'react';

const MainMobileAccordion: FC<{ children: ReactNode }> = ({ children }) => {
  const open = useHeaderStore(state => state.mobileMenuOpen);
  const [headerTop] = useStopBodyScroll(open);
  const menuRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (menuRef.current) {
      (menuRef.current as HTMLDivElement).style.height = `${window.innerHeight - headerTop}px`;
    }
  }, [headerTop]);

  return (
    <Root type="single" collapsible value={open ? 'mobile-open' : ''} asChild>
      <div className="absolute left-0 top-18 z-[999] w-full select-none">
        <Item
          ref={menuRef}
          value="mobile-open"
          className="h-[calc(100vh-72px)] overflow-auto bg-gray-900 transition-all duration-300 [&[data-state=closed]]:!h-0 [&[data-state=closed]]:overflow-hidden"
        >
          <RadContent className="h-full">
            <div className="flex h-full flex-col bg-gray-900 px-4 sm:px-16 lg:px-8">{children}</div>
          </RadContent>
        </Item>
      </div>
    </Root>
  );
};

export default MainMobileAccordion;
